import { render, staticRenderFns } from "./ListadoEventos.vue?vue&type=template&id=68c13e0e&scoped=true"
import script from "./ListadoEventos.vue?vue&type=script&lang=js"
export * from "./ListadoEventos.vue?vue&type=script&lang=js"
import style0 from "./ListadoEventos.vue?vue&type=style&index=0&id=68c13e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c13e0e",
  null
  
)

export default component.exports